import {createI18n} from "vue-i18n";
import {defaultLocale, languages} from "@/assets/locale/locale";

const messages = Object.assign(languages);

export function createI18nInstance(locale = 'ru') {
    return createI18n({
        legacy: false,
        locale: locale || defaultLocale,
        fallbackWarn: false,
        missingWarn: false,
        fallbackLocale: 'ru',
        messages,
    });
}
